import { Setting as SettingEvent } from '@repo/sdk/models/components';

import { UseWebsocketQueryOptions, WebsocketSubscription } from '@/hooks/query-hooks/websockets';
import { QueryToast } from '@/queries/types';

export interface Setting extends WebsocketSubscription {
  setting?: SettingEvent;
}

export const settingsStreamQuery = ({
  agentId,
}: {
  agentId: string | undefined;
}): UseWebsocketQueryOptions<Setting[] | null> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'settings'],
    staleTime: Infinity,
    meta: {
      toast: {
        severity: 'off',
      } as QueryToast,
    },
    webSocketUrl: `/bff/v1/agents/${agentId}/settings-stream`,
  };
};
